var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3502 1.0204L1.37831 4.39231C1.2764 4.42017 1.18555 4.47877 1.11815 4.56013C1.05075 4.64148 1.01006 4.74164 1.00164 4.84696C0.993212 4.95227 1.01746 5.05762 1.07107 5.14866C1.12468 5.2397 1.20505 5.312 1.30124 5.35571L6.79905 7.95689C6.90674 8.00677 6.99323 8.09326 7.04311 8.20095L9.64429 13.6988C9.688 13.7949 9.7603 13.8753 9.85134 13.9289C9.94238 13.9825 10.0477 14.0068 10.153 13.9984C10.2584 13.9899 10.3585 13.9493 10.4399 13.8818C10.5212 13.8144 10.5798 13.7236 10.6077 13.6217L13.9796 1.64982C14.0051 1.56246 14.0067 1.46983 13.9842 1.38165C13.9616 1.29347 13.9158 1.21297 13.8514 1.14861C13.787 1.08425 13.7065 1.03838 13.6184 1.01583C13.5302 0.99327 13.4375 0.99485 13.3502 1.0204V1.0204Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8L10 5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c829a54e47b358eaeb604df74a5da2fa.svg";
export { ForwardRef as ReactComponent };